'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProductCatalogNewCtrl
 * @description
 * # ProductNewCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('ProductCatalogNewCtrl', [
    '$scope', '$state', '$stateParams', 'ProductCatalog', 'Employee', 'GoogleApi', '$rootScope','toaster',
    function ($scope, $state, $stateParams, ProductCatalog, Employee, GoogleApi, $rootScope,toaster) {
    $rootScope.rootForm = {
      embedUrl: '',
      id: ''
    };
    $rootScope.rootFile = {
      url: '',
      id: ''
    };
    $scope.employeeList = [];

    if($stateParams.productId) {
      ProductCatalog.find($stateParams.productId).then(function(response) {
        $scope.productHash = { 'product': response.data.product_catalog };
        GoogleApi.getFolderName($scope.productHash.product.brochure_id).then(function(response) {
          $rootScope.rootFile.name = response.result.name;
        }, function(error) {
          console.log(error);
        });
        GoogleApi.getFolderName($scope.productHash.product.form_id).then(function(response) {
          $rootScope.rootForm.name = response.result.name;
        }, function(error) {
          console.log(error);
        });
      }, function(error) {
        ProductCatalog.error(error);
      });
    } else {
      $scope.productHash = {
        product: {
          'product_code': '',
          'name': '',
          'application_id': '',
          'employee_id': '',
          'brochure_url': '',
          'brochure_id': '',
          'form_url': '',
          'form_id': '',
          "product_category": null
        }
      };
    };

    Employee.index({params: {by_status: true, per_page: 'all'}}).then(function(response) {
      $scope.employeeList = response.data.employees;
    },function(error) {
      Employee.error(error);
    });

    $scope.selectForm = function() {
      GoogleApi.pickerApiLoad('1vRrxXYfoneD1QHm-EZb2GQ-J1GDI1lpi', 'form');
    }

    $scope.selectFile = function() {
      GoogleApi.pickerApiLoad('1vRrxXYfoneD1QHm-EZb2GQ-J1GDI1lpi', 'file');
    }

    $scope.saveProduct = function() {
      if ($scope.productHash.product.product_category === 'null') {
        $scope.productHash.product.product_category = null;
      }

      if($rootScope.rootForm.embedUrl !== '') {
        // jscs:disable
        $scope.productHash.product.form_url = $rootScope.rootForm.embedUrl.replace('embedded=true','');
        $scope.productHash.product.form_id = $rootScope.rootForm.id;
        // jscs:enable
      }
      if($rootScope.rootFile.url !== '') {
        // jscs:disable
        $scope.productHash.product.brochure_url = $rootScope.rootFile.url
        $scope.productHash.product.brochure_id = $rootScope.rootFile.id
        // jscs:enable

      }
      ProductCatalog.save($scope.productHash).then(function(response) {
        $scope.productHash = {
          product: {
            'product_code': '',
            'name': '',
            'application_id': '',
            'employee_id': '',
            'brochure_url': '',
            'brochure_id': '',
            'form_url': '',
            'form_id': '',
            "product_category": null
          }
        }
        toaster.pop('success', 'Producto', 'Se creo o se edito correctamente el producto');
        $state.go('app.productCatalogs.list');
      }, function(error) {
        ProductCatalog.error(error);
      });
    };
  }]);
